// extracted by mini-css-extract-plugin
module.exports = {"container":"MembersItem_container__1kG-T","item":"MembersItem_item__i-eMT","detailsBtn":"MembersItem_detailsBtn__2EKWv"};